import ScoreCricket from "./ScoreCricket";
export default ScoreCricket;
